import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface MissingEnvVarsProps {
  missingVars: string[];
}

const MissingEnvVars = ({ missingVars }: MissingEnvVarsProps) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <AlertTriangle className="mx-auto h-12 w-12 text-yellow-500" />
          <h2 className="mt-4 text-2xl font-bold text-gray-900">
            Configuration Error
          </h2>
          <p className="mt-2 text-gray-600">
            Missing required environment variables
          </p>
        </div>

        {/* Missing Variables */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="space-y-4">
            <div className="space-y-2">
              {missingVars.map((envVar) => (
                <div
                  key={envVar}
                  className="p-3 bg-red-50 border border-red-200 rounded-md text-red-700"
                >
                  {envVar}
                </div>
              ))}
            </div>

            <div className="mt-6 pt-6 border-t border-gray-200">
              <h3 className="font-medium text-gray-900 mb-3">
                How to fix:
              </h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-600">
                <li>Create a <code className="bg-gray-100 px-1.5 py-0.5 rounded text-sm">.env</code> file in project root</li>
                <li>Add the missing environment variables</li>
                <li>Restart the development server</li>
              </ol>
            </div>

            <div className="mt-4 p-4 bg-gray-50 rounded-md">
              <div className="text-sm font-medium text-gray-900 mb-2">Example .env format:</div>
              <pre className="text-sm text-gray-600 whitespace-pre-wrap">
                {missingVars.map((envVar) => `${envVar}=your_value_here\n`).join('')}
              </pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissingEnvVars;